export const APP_TOAST_EVENT = "cartnom:toast";

export function emitToast({ message, type = "info", duration = 3500, important = false }) {
  if (!message || typeof window === "undefined") return;
  if ((type === "success" || type === "info") && !important) return;
  window.dispatchEvent(
    new CustomEvent(APP_TOAST_EVENT, {
      detail: { message, type, duration, important },
    })
  );
}

export const toast = {
  success(message, duration, options = {}) {
    emitToast({ message, type: "success", duration, ...options });
  },
  error(message, duration) {
    emitToast({ message, type: "error", duration });
  },
  info(message, duration, options = {}) {
    emitToast({ message, type: "info", duration, ...options });
  },
};
